import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import { ConvertDateTimeToText, Switch } from "components/MyControl";

export default function ConfigEmailDetail() {
    const api = new ApiConection();
    const { id } = useParams();
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('view');
    const [initialData, setInitialData] = useState({});
    const [simulate, setSimulate] = useState({});

    const getData = async () => {
        const response = await api.getData(`api/ConfigEmail/${id}`);
        if (response.status === true) {
            setSimulate(response.data);
            setInitialData(response.data);
        }
    }

    const handleSetSimulate = async (event) => {
        const { type, name, value, checked } = event.target;
        if (type === 'checkbox')
            setSimulate(preData => { return { ...preData, [name]: checked } });
        else
            setSimulate(preData => { return { ...preData, [name]: value } });
    }

    const handleCancel = (event) => {
        setSimulate(initialData)
        setMode('view')
    }

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);
        debugger;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        let data = {
            host: simulate.host,
            port: simulate.port,
            data_type: simulate.data_type,
            enable_ssl: simulate.enable_ssl,
            sender_email: simulate.sender_email,
            sender_display_name: simulate.sender_display_name,
            email_timeout: simulate.email_timeout
        }

        if (simulate.sender_password.trim() !== '')
            data.sender_password = simulate.sender_password;

        const response = await api.putData(`api/ConfigEmail/${id}`, data);

        if (response.status === true) {
            await getData();
            setMode('view');
        } else {
            setAlert(response.message);
            setMode('edit');
        }

        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, [])

    return (
        <Layout4Admin1 >
            <div className={Css.Block_Transparent}>
                <div className='contrainermt-3 mb-3'>
                    <Form noValidate validated={validated} onSubmit={event => handleSubmit(event)} >
                        <div className={`border rounded p-4 bg-white shadow w-100`}>
                            <div>
                                <Row>
                                    <Col>
                                        <h5 className='text-start mb-0'>
                                            ตั้งค่าเซอร์เวอร์ส่งอีเมล
                                        </h5>
                                        <Form.Text className="mb-5">ข้อมูลตัวแปรต่างๆ ที่ระบบ หรือโปรแกรมใช้งาน เมื่อทำการบันทึก จะมีผลกับระบบทันที</Form.Text>
                                    </Col>
                                    <Col className='text-end'>
                                        {
                                            mode === 'view' &&
                                            <Button variant="outline-secondary" type="button" className=''
                                                onClick={event => setMode('edit')}>
                                                แก้ไข
                                                <i className="ms-2 fa-solid fa-pencil"></i>
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </div>
                            <div className="mt-5">
                                <Row className='mb-5'>
                                    <Col className='me-3'>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>Host</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'host'}
                                                value={simulate?.host}
                                                onChange={handleSetSimulate}
                                                placeholder="host" required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>Port</Form.Label>
                                            <Form.Control type={'number'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'port'}
                                                value={simulate?.port}
                                                onChange={handleSetSimulate}
                                                placeholder="port" required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>Enable SSL</Form.Label>
                                            <Form.Switch name={'enable_ssl'}
                                                disabled={(mode === 'view') ? true : false}
                                                checked={simulate?.enable_ssl}
                                                placeholder="port" required={true}
                                                onChange={handleSetSimulate} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>Sender Email</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'sender_email'}
                                                value={simulate?.sender_email}
                                                onChange={handleSetSimulate}
                                                placeholder="sender_email" required={true} />
                                        </Form.Group>
                                        {
                                            simulate?.enable_ssl === true &&
                                            <Form.Group className='mb-3'>
                                                <Form.Label className='label-title'>Sender Password</Form.Label>
                                                <Form.Control type={'password'}
                                                    plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false}
                                                    className=''
                                                    name={'sender_password'}
                                                    value={simulate?.sender_password}
                                                    onChange={handleSetSimulate}
                                                    placeholder="sender_password" required={true} />
                                            </Form.Group>
                                        }

                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>Sender Display Name</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'sender_display_name'}
                                                value={simulate?.sender_display_name}
                                                onChange={handleSetSimulate}
                                                placeholder="sender_display_name" required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>Time Out(s)</Form.Label>
                                            <Form.Control type={'number'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'email_timeout'}
                                                value={simulate?.email_timeout}
                                                onChange={handleSetSimulate}
                                                placeholder="email_timeout" required={true} />
                                        </Form.Group>
                                    </Col>
                                    <Col className="me-3">
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">ผู้บันทึก</Form.Label>
                                            <Form.Label>{simulate?.modify_by}&nbsp;</Form.Label>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">วันที่บันทึกล่าสุด</Form.Label>
                                            <Form.Label>{ConvertDateTimeToText(simulate?.modify_date)}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                            {
                                alert != '' &&
                                <div className="alert alert-danger" role="alert">
                                    {alert}
                                </div>
                            }

                            {
                                mode === 'edit' &&
                                <Row>
                                    <Col>
                                        <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                            onClick={event => handleCancel(event)}  >ยกเลิก</Button>
                                        <Button variant="primary" type="submit" className='ps-5 pe-5'
                                            disabled={loading}
                                        >บันทึก
                                            {
                                                loading === true &&
                                                <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            }
                                        </Button>
                                    </Col>
                                </Row>
                            }
                        </div>
                    </Form>
                </div>
            </div>
        </Layout4Admin1>
    );
}